import type { FC } from 'react';
import type { MatchScoreRowProps } from './MatchScoreRow.types';
import styles from './MatchScoreRow.module.scss';
export const MatchScoreRow: FC<MatchScoreRowProps> = ({
  stats,
  title
}) => {
  const isHomeBigger = (stats?.HOME ?? 0) > (stats?.AWAY ?? 0);
  const isAwayBigger = (stats?.HOME ?? 0) < (stats?.AWAY ?? 0);
  if (!stats) {
    return null;
  }
  return <div className={styles.root} data-sentry-component="MatchScoreRow" data-sentry-source-file="MatchScoreRow.tsx">
      <div className={cn(styles.col, styles.leftCol, isHomeBigger && styles.strong)}>
        <span className={styles.stats}>{stats?.HOME || 0}</span>
      </div>
      <div className={cn(styles.col, styles.title)}>{title}</div>
      <div className={cn(styles.col, styles.rightCol, isAwayBigger && styles.strong)}>
        <span className={styles.stats}>{stats?.AWAY || 0}</span>
      </div>
    </div>;
};